// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Obtener la referencia al elemento del portal aquí, una vez
const modalRoot = document.getElementById('modal-root');

// Verificar si se encontró el elemento (para depuración)
if (!modalRoot) {
  console.error("Error: El elemento con id 'modal-root' no fue encontrado en index.html.");
}

root.render(
  //<React.StrictMode>
    <App modalRoot={modalRoot} /> 
  //</React.StrictMode>
);


